<template lang="pug">
#Notice.w-50.bg-white.ph3.pv2.center.shadow-2.br3(v-show="!dismissed")
    p Wine regions can be any color and are official unless noted otherwise. Click on a region's label or its border for details. Also, this site uses cookies.
        small.pl3
            a(href="#" @click="dismissed=true") Accept and dismiss

</template>

<script>
export default {
    name: 'Notice',
    data: () => ({
        dismissed: Boolean(
            window.localStorage.getItem('region-notice-dismissed')
        ),
    }),
    created() {
        window.Notice = this;
    },
    watch: {
        dismissed() {
            window.localStorage.setItem(
                'region-notice-dismissed',
                this.dismissed
            );
        },
    },
};
</script>

<style scoped>
#Notice {
    /* margin-top: -30px; */
    pointer-events: all !important;
}
</style>
